module.exports = __webpack_public_path__ + "img/mall08.d7bafdca.png";